import setManualLookupDataSaga from './set_manual_lookup_data';
import finaliseManualLookupSaga from './finalise_manual_lookup';
import setFiltersExcessCoverTypeSaga from './set_filters_excess_covertype';
import preSetRestrictionsSaga from './pre_set_restrictons';
import postPayloadIfTransaction from './post_payload_if_transaction';
import setExcessByState from './set_excess_by_state';
import setExcessByStateSelector from './set_excess_by_state_selector';
import setCoverTypeValueSaga from './set_cover_type_value';
import { syncHealthLeadCaptureVisibility } from './health_lead_capture_visibility';
import auth0SessionTransferSaga from './auth0_session_transfer';
import auth0FlowSagas from './auth0_flow';
import auth0CompletionSaga from './auth0_completion';

export const verticalSagas = [
    setManualLookupDataSaga,
    finaliseManualLookupSaga,
    setFiltersExcessCoverTypeSaga,
    preSetRestrictionsSaga,
    postPayloadIfTransaction,
    setExcessByState,
    setExcessByStateSelector,
    setCoverTypeValueSaga,
    syncHealthLeadCaptureVisibility,
    auth0SessionTransferSaga,
    ...auth0FlowSagas,
    auth0CompletionSaga
];
